// extracted by mini-css-extract-plugin
export default {"user-table":"User_user-table__tO5Xi","user-table__action":"User_user-table__action__ALL3K","user-table__action--button":"User_user-table__action--button__6wg8G"};